module.exports = __webpack_public_path__ + "img/1791991483390.18dfb854.png";